import ApiService from '@/common/api.service'
import ErrorsService from './errors.service'
import { FORGOT_PASSWORD, CHECH_PASSWORD_TOKEN, RESET_PASSWORD, FETCH_PROFILE } from './actions.type'
import { SET_PROFILE, SET_PROFILE_ERRORS, SET_PROFILE_LOADING, SET_FORGOT_PASSWORD, SET_FORGOT_PASSWORD_ERRORS, SET_FORGOT_PASSWORD_LOADING, SET_RESET_PASSWORD, SET_RESET_PASSWORD_ERRORS, SET_RESET_PASSWORD_LOADING } from './mutations.type'

const state = {
	profile: null,
	profileErrors: [],
	profileIsLoading: false,
	forgotPasswordErrors: [],
	forgotPasswordIsLoading: false,
	resetPasswordErrors: [],
	resetPasswordIsLoading: false
}

const getters = {
	profile (state) {
		return state.profile
	},
	profileErrors (state) {
		return state.profileErrors
	},
	profileIsLoading (state) {
		return state.profileIsLoading
	},
	forgotPasswordErrors (state) {
		return state.forgotPasswordErrors
	},
	forgotPasswordIsLoading (state) {
		return state.forgotPasswordIsLoading
	},
	resetPasswordErrors (state) {
		return state.resetPasswordErrors
	},
	resetPasswordIsLoading (state) {
		return state.resetPasswordIsLoading
	}
}

const actions = {
	[FORGOT_PASSWORD] (context, params) {
		context.commit(SET_FORGOT_PASSWORD_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(FORGOT_PASSWORD, params)
			.then(({data}) => {
				context.commit(SET_FORGOT_PASSWORD)
				resolve(data)	
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_FORGOT_PASSWORD_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_FORGOT_PASSWORD_LOADING, false)
			})
		})
	},
	[RESET_PASSWORD] (context, params) {
		context.commit(SET_RESET_PASSWORD_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(RESET_PASSWORD, params)
			.then(({data}) => {
				context.commit(SET_RESET_PASSWORD)
				resolve(data)
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_RESET_PASSWORD_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_RESET_PASSWORD_LOADING, false)
			})
		})
	},
	[CHECH_PASSWORD_TOKEN] (context, params) {
		context.commit(SET_RESET_PASSWORD_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.post(CHECH_PASSWORD_TOKEN, params)
			.then(({data}) => {
				context.commit(SET_RESET_PASSWORD)
				resolve(data)
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_RESET_PASSWORD_ERRORS, context, error)
				resolve(false)
			})
			.finally(x => {
				context.commit(SET_RESET_PASSWORD_LOADING, false)
			})
		})
	},
	[FETCH_PROFILE] (context) {
		context.commit(SET_PROFILE_LOADING)
		return new Promise((resolve, reject) => {
			ApiService.get(FETCH_PROFILE)
			.then(({data}) => {
				if (typeof data == "object") {
					context.commit(SET_PROFILE, data)
					resolve(data)
				} else {
					context.commit(SET_PROFILE_ERRORS, ["Разрыв сессии"])
				}
			})
			.catch((error) => {
				ErrorsService.setFetchError(SET_PROFILE_ERRORS, context, error)
			})
			.finally(x => {
				context.commit(SET_PROFILE_LOADING, false)
			})
		})
	}
}

const mutations = {
	[SET_PROFILE] (state, data) {
		state.profile = data
		state.profileErrors = []
	},
	[SET_PROFILE_ERRORS] (state, errors) {
		state.profile = null
		state.profileErrors = errors
	},
	[SET_PROFILE_LOADING] (state, status = true) {
		state.profileIsLoading = status
	},
	[SET_FORGOT_PASSWORD] (state) {
		state.forgotPasswordErrors = []
	},
	[SET_FORGOT_PASSWORD_ERRORS] (state, errors) {
		state.forgotPasswordErrors = errors
	},
	[SET_FORGOT_PASSWORD_LOADING] (state, status = true) {
		state.forgotPasswordIsLoading = status
	},
	[SET_RESET_PASSWORD] (state) {
		state.resetPasswordErrors = []
	},
	[SET_RESET_PASSWORD_ERRORS] (state, errors) {
		state.resetPasswordErrors = errors
	},
	[SET_RESET_PASSWORD_LOADING] (state, status = true) {
		state.resetPasswordIsLoading = status
	}
}

export default {
	state,
	actions,
	mutations,
	getters
}


// WEBPACK FOOTER //
// ./src/store/profile.module.js